import Vue from 'vue'
import Router from 'vue-router'
import store from "./store";

import Landing from "./views/landing";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: "thankyou",
      component: () => import("./views/thank-you.vue")
    }

  ]
});